import { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import {
  useProcedureRoomsStore,
  useSelectFormStore,
  useForm,
} from "../../../hooks";
import { replaceNullToEmpty } from "../../../helpers";
import {
  InputForm,
  SelectForm,
  LoadingData,
  ErrorMessage,
  CancelButton,
  MainButton,
} from "../../ui";
import { useFormMessages } from "../../hooks";

const formValidations = {
  name: [(value) => value.length > 0, "El nombre no puede ser vacio"],
  headquarterId: [(value) => value.length > 0, "Selecciona una sede"],
};

const initialFormData = {
  id: "",
  name: "",
  number: "",
  letter: "",
  headquarterId: "",
};

export const ModalEditProcedureRoom = ({
  editProcedureRoom,
  setEditProcedureRoom,
  procedureRoom,
}) => {
  // Datos del hook ----------------------------------------//
  const {
    // Props
    message,
    isLoading,

    // Methods
    startUpdateProcedureRoom,
  } = useProcedureRoomsStore();

  const { headquarters } = useSelectFormStore(["headquarters"]);

  // States ------------------------------------------------//
  const [validateForm, setValidateForm] = useState(false);
  const [formData, setFormData] = useState(initialFormData);

  // Formulario --------------------------------------------//
  const { formState, formValidation, onInputChange, isFormValid } = useForm(
    formData,
    formValidations
  );

  const {
    setFormSubmitted,
    showErrorMessage,
    showSuccessMessage,
    messageText,
  } = useFormMessages({
    message,
    setValidateForm,
  });

  const { name, number, letter, headquarterId } = formState;

  const { nameValid, headquarterIdValid } = formValidation;

  // Funciones ---------------------------------------------//
  const onUpdateProcedureRoom = () => {
    setValidateForm(true);
    if (isFormValid) {
      setFormSubmitted(true);
      startUpdateProcedureRoom(formState);
    }
  };

  // Efectos -----------------------------------------------//
  useEffect(() => {
    if (procedureRoom) {
      const { headquarterName, ipsId, ipsName, ...newProcedureRoom } =
        procedureRoom;

      setFormData({
        ...replaceNullToEmpty(newProcedureRoom),
      });
    }
  }, [procedureRoom]);

  // ...(({ procedure, ...result }) => result)(
  //   patientSurgery.procedure
  // ),

  useEffect(() => {
    if (!editProcedureRoom) {
      setFormData(initialFormData);
      setValidateForm(false);
      setFormSubmitted(false);
    }
  }, [editProcedureRoom]);

  useEffect(() => {
    if (showSuccessMessage) {
      setEditProcedureRoom(false);
    }
  }, [showSuccessMessage]);

  return (
    <Modal
      show={editProcedureRoom}
      onHide={() => {
        setEditProcedureRoom(false);
      }}
      centered
      size="lg"
    >
      <Modal.Header closeButton>
        <h5 className="modal-title" id="exampleModalLabel1">
          Editar Sala de procedimiento
        </h5>
      </Modal.Header>
      <Modal.Body>
        <div className="row g-3">
          {/* Formulario estatico */}
          <>
            <div className="col-md-6">
              <InputForm
                label={"Nombre"}
                type={"text"}
                placeholder={"Nombre"}
                validation={nameValid}
                submit={validateForm}
                name={"name"}
                value={name}
                onInputChange={onInputChange}
              />
            </div>
            <div className="col-md-3">
              <InputForm
                label={"Número"}
                sublabel={"Opcional"}
                type={"number"}
                placeholder={"Número"}
                submit={validateForm}
                name={"number"}
                value={number}
                onInputChange={onInputChange}
              />
            </div>
            <div className="col-md-3">
              <InputForm
                label={"Letra"}
                sublabel={"Opcional"}
                type={"text"}
                placeholder={"Letra"}
                submit={validateForm}
                name={"letter"}
                value={letter}
                onInputChange={onInputChange}
              />
            </div>
            <div className="col-md-6">
              <SelectForm
                label={`Sede - ips`}
                options={headquarters}
                labelKey={"name"}
                validation={headquarterIdValid}
                submit={validateForm}
                name={`headquarterId`}
                value={headquarterId}
                onInputChange={onInputChange}
              />
            </div>
          </>

          {/* Mensajes */}
          <>
            {isLoading && (
              <div className="col-md-12">
                <LoadingData />
              </div>
            )}
            {showErrorMessage && (
              <div className="col-md-12">
                <ErrorMessage>{messageText}</ErrorMessage>
              </div>
            )}
          </>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <CancelButton
          type={"button"}
          onClick={() => setEditProcedureRoom(false)}
          disabled={isLoading}
        >
          Cancelar
        </CancelButton>
        <MainButton
          type={"button"}
          onClick={() => onUpdateProcedureRoom()}
          disabled={isLoading}
        >
          Guardar cambios
        </MainButton>
      </Modal.Footer>
    </Modal>
  );
};
